import React from 'react'

const Loader = ({ width, isLoadingMap }: { isLoadingMap: boolean; width: string }) => {
  return (
    <>
      <div
        className={
          'section-loader-map ' +
          (isLoadingMap ? 'div-loading-map ' : ' ') +
          (width === 'full' && 'w-100')
        }
      >
        <span className="loader"></span>
      </div>
    </>
  )
}

export default Loader
